//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../Mechatronics/Mechatronics.CollisionShapeBuilder.js";
import "../no/Expression.js";
import "../no/SelectNXObjectList.js";
import "../no/Expression.js";
import "../no/SelectObjectList.js";
let d=[[[1,"Angle",0,"Expression",0],[0,"BeamType",1,0],[0,"Category",1,0],[0,"Count",1,0],[1,"CycleTime",0,"Expression",0],[0,"ExcludedBeams",1,0],[1,"FieldHeight",0,"Expression",0],[1,"Geometry",0,"SelectNXObjectList",0],[0,"Name",1,0],[1,"Range",0,"Expression",0],[0,"ShowInSimulation",1,0]],[[["geometries"],"SetGeometry",{},1,0]],[]];
SPLM.Mechatronics.LightCurtainBuilder = class extends SPLM.Mechatronics.CollisionShapeBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.LightCurtainBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.LightCurtainBuilder.BeamTypes = Object.freeze({
    "SingleBeam" : "SingleBeam", "ThreeBeams" : "ThreeBeams", "FiveBeams" : "FiveBeams"});

export default SPLM;